// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collapseable-table-body .user-profile-img {
  width: 32px;
  height: 40px;
}
.collapseable-table-body .link-color {
  color: #59A9FF !important;
}`, "",{"version":3,"sources":["webpack://./src/features/bookings/common/collapsable-table/collapsable-table.scss"],"names":[],"mappings":"AACI;EACI,WAAA;EACA,YAAA;AAAR;AAEI;EACI,yBAAA;AAAR","sourcesContent":[".collapseable-table-body{\n    .user-profile-img {\n        width: 32px;\n        height: 40px;\n    }\n    .link-color{\n        color: #59A9FF !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
